// The checkout payment step's "Payment Split" (prepayment invoice) option.
//
// This option is deliberately NOT a WooCommerce gateway — see
// AMENITIES_CHECKOUT_BANK_TRANSFER_METHOD in includes/checkout-steps.php. Its order is built by
// amenities_create_direct_bank_transfer_order() (functions-ajax.php), a parallel implementation of
// WC_Checkout, so it must not travel through the native form submit. Hence a type="button" CTA
// (never submits) and this handler, which replaces the bacs fork of the old checkout.js
// createOrder(). Markup comes from woocommerce/checkout/payment.php.
//
// EVERYTHING HERE IS DELEGATED FROM `document`, deliberately. wc-checkout re-renders the whole
// payment area by AJAX (`?wc-ajax=update_order_review`) and replaces `.woocommerce-checkout-payment`
// — which is `#payment` — wholesale, at minimum once on `init_checkout`. Any listener bound
// directly to a node inside it is silently thrown away with the old DOM, which is exactly what
// happened first time round: the radios responded to nothing, because the elements the listeners
// were attached to no longer existed. Delegation survives the swap; `updated_checkout` re-syncs the
// state that has no event of its own.
const BANK_TRANSFER_METHOD = 'amenities_bank_transfer';

function showError(container, message) {
    let notice = container.querySelector('.woocommerce-error');

    if (!notice) {
        notice = document.createElement('ul');
        notice.className = 'woocommerce-error';
        notice.setAttribute('role', 'alert');
        container.prepend(notice);
    }

    notice.innerHTML = '';

    const item = document.createElement('li');
    item.textContent = message;
    notice.appendChild(item);

    notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function clearError(container) {
    const notice = container.querySelector('.woocommerce-error');

    if (notice) notice.remove();
}

// The native place-order button and this option's own CTA are mutually exclusive: the former
// submits into process_checkout(), which would reject a non-gateway payment method.
function syncPlaceOrder() {
    const placeOrder = document.querySelector('.payment #payment .form-row.place-order');

    if (!placeOrder) return;

    const checked = document.querySelector('.payment #payment input[name="payment_method"]:checked');

    placeOrder.hidden = !!checked && checked.value === BANK_TRANSFER_METHOD;
}

function submitBankTransfer(button) {
    const card = button.closest('.payment__card') || button.parentElement;

    clearError(card);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');

    const release = () => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
    };

    const terms = document.getElementById('terms');

    const body = new URLSearchParams({
        action: 'amenities_create_direct_bank_transfer_order',
        nonce: button.dataset.nonce || '',
        terms: terms && terms.checked ? '1' : '',
    });

    // WooCommerce's order-attribution inputs (traffic source), which its <wc-order-attribution-inputs>
    // element fills inside the checkout form. See includes/woocommerce/order-attribution.php.
    const form = button.closest('form');

    if (form) {
        for (const [name, value] of new FormData(form)) {
            if (name.startsWith('wc_order_attribution_') && typeof value === 'string') {
                body.append(name, value);
            }
        }
    }

    fetch(twf.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
    })
        .then((response) => response.json())
        .then((data) => {
            if (data && data.status === 'success' && data.data && data.data.order_received_url) {
                window.location.href = data.data.order_received_url;

                return;
            }

            showError(card, (data && data.message) || twf.products_error_msg);
            release();
        })
        .catch(() => {
            showError(card, twf.products_error_msg);
            release();
        });
}

document.addEventListener('change', (event) => {
    if (event.target.name === 'payment_method') syncPlaceOrder();
});

document.addEventListener('click', (event) => {
    const button = event.target.closest('#amenities-bank-transfer-submit');

    if (button) submitBankTransfer(button);
});

// `updated_checkout` is a jQuery-triggered event, so it needs a jQuery listener to be observed;
// a native addEventListener never sees it.
if (window.jQuery) {
    window.jQuery(document.body).on('updated_checkout', syncPlaceOrder);
}

document.addEventListener('DOMContentLoaded', syncPlaceOrder);
